import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Country } from '../model/country';

@Injectable({
    providedIn: 'root'
  })
  export class CountryService{
  
    constructor(private _restClientService : RestClientService) { }

    getAllCountries() {
      return this._restClientService.load<Country[]>('country/get');
    }

    getCountryById(countryId)
    {
      return this._restClientService.load<Country>('country/get/'+countryId);
    }


    putCountry(country) 
    {
      return  this._restClientService.put<Country>(`country/update`, country);
    }



}      

    